import PropTypes from 'prop-types';
import coProductProps from './coProduct';
import constraintCategoryProps from './constraintCategory';

export default PropTypes.shape({
  category: constraintCategoryProps,
  coProducts: PropTypes.arrayOf(coProductProps),
});
